module.exports = __webpack_public_path__ + "img/embarrassment.38e330e2.svg";